import Navbar from "../components/site/Navbar";
import { Helmet } from "react-helmet-async";
import Hero from "../components/site/Hero";
import MarqueeStrip from "../components/site/MarqueeStrip";
import Services from "../components/site/Services";
import Founder from "../components/site/Founder";
import Team from "../components/site/Team";
import ProcessIndustries from "../components/site/ProcessIndustries";
import Stats from "../components/site/Stats";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function Home() {
  return (
    <div className="bg-[#030712]" data-testid="home-page">
      <Helmet>
        <title>Your HR Partner - Yes Global Consultants</title>
        <meta name="description" content="Yes Global Consultants is a Delhi-based executive search & HR consulting firm placing transformational leaders across India, the UAE and the US." />
        <link rel="canonical" href="https://yesconsultants.in/" />
      </Helmet>
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Services />
        <Founder />
        <Team />
        <ProcessIndustries />
        <Stats />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
